module.exports = __webpack_public_path__ + "static/media/Johannes.5e866e44.png";